// MaintenanceBannerPublic.jsx
import React, { useEffect, useRef, useState } from "react";
import { fetchPublicGlobalSettings } from "../../http/bookAPI";

const MaintenanceBanner = () => {
    const [settings, setSettings] = useState(null);
    const [startsInMinutes, setStartsInMinutes] = useState(null);
    const startsInRef = useRef(null);

    const applySettings = (data) => {
        if (data?.update_active) {
            const minutes = Number(data.maintenance_starts_in_minutes ?? data.update_duration_minutes ?? 0);
            const safeMinutes = Number.isFinite(minutes) ? Math.max(0, Math.ceil(minutes)) : 0;
            setSettings(data);
            setStartsInMinutes(safeMinutes);
            startsInRef.current = safeMinutes;
            return;
        }

        setSettings(null);
        setStartsInMinutes(null);
        startsInRef.current = null;
    };

    const load = async () => {
        try {
            const data = await fetchPublicGlobalSettings();
            applySettings(data);
        } catch (err) {
            setSettings(null);
            setStartsInMinutes(null);
            startsInRef.current = null;
        }
    };

    useEffect(() => {
        load();

        const poll = setInterval(load, 300000);
        const tick = setInterval(() => {
            if (startsInRef.current === null) return;
            const next = Math.max(0, startsInRef.current - 1);
            startsInRef.current = next;
            setStartsInMinutes(next);
        }, 60000);

        return () => {
            clearInterval(poll);
            clearInterval(tick);
        };
    }, []);

    if (!settings) return null;

    return (
        <div
            style={{
                background: "#b02a37",
                color: "white",
                padding: "10px",
                textAlign: "center",
                fontWeight: "bold",
                fontSize: 14,
            }}
            role="alert"
        >
            {settings.update_message}{" "}
            {startsInMinutes > 0
                ? `- maintenance starts in: ${formatStartsIn(startsInMinutes)}`
                : "- maintenance is starting now."}
        </div>
    );
};

function formatStartsIn(totalMinutes) {
    const minutesSafe = Math.max(0, Number(totalMinutes) || 0);
    const hours = Math.floor(minutesSafe / 60);
    const minutes = minutesSafe % 60;

    if (hours <= 0) return `${minutes}m`;
    if (minutes <= 0) return `${hours}h`;
    return `${hours}h ${minutes}m`;
}

export default MaintenanceBanner;
